// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"a75707ff","206":"8215554c","694":"a75707ff","695":"f683d37d","819":"a75707ff","841":"ab36a165"}[chunkId] + ".chunk.css";
};